var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.client)?_c('counterparties-user',{attrs:{"client":_vm.client}}):_vm._e(),_c('counterparties-user-tabs',{attrs:{"links":_vm.linksByPermission,"client":_vm.client}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }